<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 32 32" xml:space="preserve">
    <path :fill="color" d="M16,4v2C10.486,6,6,10.486,6,16s4.486,10,10,10s10-4.486,10-10c0-3.594-1.937-6.866-5-8.64V11 h-2V4h7v2h-3.375C25.941,8.199,28,11.933,28,16c0,6.617-5.383,12-12,12S4,22.617,4,16S9.383,4,16,4z"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71717A'
    },
  },
};
</script>
